import { render, staticRenderFns } from "./yjbck.vue?vue&type=template&id=5dfb30a0&scoped=true&"
import script from "./yjbck.vue?vue&type=script&lang=js&"
export * from "./yjbck.vue?vue&type=script&lang=js&"
import style0 from "./yjbck.vue?vue&type=style&index=0&id=5dfb30a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfb30a0",
  null
  
)

export default component.exports